<template>
    <section
            class="main"
            style="position:relative; margin: 0 auto"
            :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}"
    >

        <v-container style="max-width: 1200px; margin: 0 auto">
            <v-row justify="center">
                <v-col class="text" :cols="12" :style="{'font-size': block.fontSize + 'px'}">
                    <div v-html="block.content"></div>
                </v-col>
            </v-row>
        </v-container>

    </section>
</template>

<script>

    export default {
        props:['block'],
        name: "TextBlock",
        data(){
            return {
            }
        }

    }
</script>

<style scoped>

    .text{
        color: #000000;
        /*font-size: 3px;*/
        /*line-height: 1.35;*/
        font-family: 'PT Sans',Arial,sans-serif;
        /*font-weight: 400;*/
    }

    .text textarea{
        width: 100%;
        position: relative;
        overflow: auto;
        z-index: 100;
        height:350px
    }

    .text-align-justify{
        text-align: justify;
    }

    .text-align-left{
        text-align: left;
    }

    .text-align-right{
        text-align: right;
    }

    .text-align-center{
        text-align: center;
    }

    .main{

    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }

</style>
